module.exports = __webpack_public_path__ + "static/media/logo.dce3a79d.svg";